/** Map legacy Vuetify 2 header shape ({ text, value }) to Vuetify 3 ({ title, key }). */
export function vuetifyHeaders(headers) {
  return (headers || []).map((header) => {
    const key = header.key ?? header.value ?? '';
    return {
      ...header,
      title: header.title ?? header.text ?? '',
      key,
      value: undefined,
      text: undefined,
    };
  });
}
